import { combineReducers } from 'redux';
import {
  NEWS_TARGETS_UPDATED,
  NEWS_TARGET_CLEARED,
} from 'news/actions/diffusion';
import { INITIAL_DATA_LOAD_SUCCESS } from 'news/actions';

const targets = (state = [], action) => {
  switch (action.type) {
    case NEWS_TARGETS_UPDATED:
    case INITIAL_DATA_LOAD_SUCCESS:
      return action.targets;
    case NEWS_TARGET_CLEARED:
      return [];
    default:
      return state;
  }
};

export default combineReducers({
  targets,
});

export const getTargets = state => state.diffusion.targets;



// WEBPACK FOOTER //
// ./src/modules/news/reducers/diffusion.js